document.addEventListener('DOMContentLoaded', () => {
  updateMiniCart(); // Update mini cart on page load

  // Add event listener for quantity change
  document.querySelectorAll('.quantity input').forEach(input => {
    input.addEventListener('change', handleQuantityChange);
  });
});

function handleQuantityChange(event) {
  const input = event.target;
  const variantId = input.getAttribute('data-variant-id');
  const quantity = input.value;

  updateCart(variantId, quantity);
}

function updateCart(variantId, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart updated:', data);
    updateMiniCart(); // Refresh the mini cart
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

function updateMiniCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const miniCart = document.querySelector('.thb-cart-dropdown');
      const dropdownTitle = miniCart.querySelector('.dropdown-title');
      const cartEmpty = miniCart.querySelector('.cart-empty');
      const subtotal = miniCart.querySelector('.subtotal .price');
      const cartValue = document.querySelector('.thb-cart-value'); // Select the element
      const button = miniCart.querySelector('.button');
      const cartItemsContainer = miniCart.querySelector('.cart-items-container');
      const itemCount = document.querySelector('.thb-item-count'); // Select the element

      dropdownTitle.textContent = `Ihr Warenkorb (${cart.item_count})`;
      itemCount.textContent = cart.item_count; // Update the item count

      if (cart.item_count > 0) {
        cartEmpty.style.display = 'none';
        button.style.display = 'block';
        const totalPriceFormatted = formatMoney(cart.total_price, window.moneyFormat);
        subtotal.textContent = totalPriceFormatted;
        cartValue.textContent = totalPriceFormatted; // Update the cart value

        // Clear the previous cart items
        cartItemsContainer.innerHTML = '';

        // Add the new cart items
        cart.items.forEach(item => {
          const cartItem = document.createElement('div');
          cartItem.classList.add('cart-item');
          cartItem.innerHTML = `
            <div class="cart-item-image">
              <img src="${item.image}" alt="${item.product_title}">
            </div>
            <div class="cart-item-details">
              <div class="cart-item-title">${item.product_title}</div>
              <div class="cart-item-price">${formatMoney(item.final_line_price, window.moneyFormat)}</div>
            </div>
          `;
          cartItemsContainer.appendChild(cartItem);
        });

      } else {
        cartEmpty.style.display = 'block';
        button.style.display = 'none';
        subtotal.textContent = '€0.00';
        cartValue.textContent = '0.00 lei'; // Update the cart value to zero
      }
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

function vProductAddToCartForm(element) {
  var variantId = element.getAttribute('data-sku');
  var quantity = element.getAttribute('data-quantity') || 1;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    updateMiniCart();
  })
  .catch(error => {
    console.error('Error adding product to cart:', error);
  });
}

function formatMoney(amount, format) {
  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  let value = '';

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  switch (format || '') {
    case 'money':
      value = formatWithDelimiters(amount, 2);
      break;
    case 'money_with_currency':
      value = formatWithDelimiters(amount, 2) + ' ' + window.shopCurrency;
      break;
    case 'money_without_trailing_zeros':
      value = formatWithDelimiters(amount, 2).replace(/(\.00$|0$)/, '');
      break;
    default:
      value = formatWithDelimiters(amount, 2);
      break;
  }

  return format.replace(placeholderRegex, value);
}
